/* globals alert, clearTimeout, console, module, require, setTimeout */
/* jshint esversion:6, globalstrict:true */
/* jscs:disable disallowDanglingUnderscores */
'use strict';

// @acavan! - this should be something like filterSummarySet

const BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    FiltersList = require('./filtersList'),
    FilterSetsList = require('./filterSetsList'),
    ModalDialog = require('./modalDialog'),
    user = require('../models/user'),
    // Filters = require('../collections/filters'),
    FilterSets = require('../collections/filterSets'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor'),
    templates = require('../utilities/handlebars').templates,
    helpers = require('../utilities/handlebars').helpers,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        name: 'filterSet',
        class: 'filter-set'
    },
    channels: {
        analytics: BackboneRadio.channel('analytics'),
        vaultOut: BackboneRadio.channel('vaultInterface:out')
    },
    childViewEvents: {
        'update:filterSet': 'onUpdateFilterSet',
        'delete:filterSet': 'onDeleteFilterSet',
        'select:filterSet': 'onSelectFilterSet',
        //
        'clear:group': function (group) {this.trigger('clear:group', group);},
        'clear:filterSet': function () {this.trigger('clear:filterSet');},
        'location:cleared': function () {this.trigger('location:cleared');}
    },
    currentFilterSet: null,
    events: {
        'click button': 'onClickButton'
    },
    regions: {
        filtersList: 'div[name=filtersList]',
        filterSetsList: 'div[name=filterSetsList]'
    },
    tagName: 'div',
    template: templates.filterSet,
    ui: {
        clearFilterSet:  'button[name=clearFilterSet]',
        deleteFilterSet: 'button[name=deleteFilterSet]',
        saveFilterSet:   'button[name=saveFilterSet]',
        saveFilterSetAs: 'button[name=saveFilterSetAs]',
        updateFilterSet: 'button[name=updateFilterSet]'
    },
    initialize: function () {
        this.serializeFilters = this.options.serializeFilters;
        this.filters = this.options.filters;
        this.filterSets = new FilterSets();
        _.defer(_.bind(function () {
            this.showButtons({disabled: ['saveFilterSet']}, 'initialize');
        }, this));
        this.listenTo(this.filterSets, 'add', _.bind(function (model) {
            this.currentFilterSet = model;
        }, this));
        this.listenTo(user, 'change:JWT', _.bind(function () {
            if (!user.isSignedIn()) {
                // clean up when user signs out
                this.filterSets.reset([]);
                this.onClickButton({action: 'clearFilterSet'});
                this.pendingSaveFilters = '';
            // } else if (!this.filters.length) {
            } else {
                // don't overwrite filters (if any) on sign in
                // @acavan! do we need to do this if there aren't any filters?
                if (this.pendingSaveFilters && this.pendingSaveFilters === JSON.stringify(this.filters.getFilterSet())) {
                    this.onClickButton({action: 'saveFilterSet'});
                }
                // this.onClickButton({action: 'clearFilterSet'});
            }
        }, this));
    },
    onClickButton: function (event) {
        // save - shown disabled when no filter set is loaded, enabled when a filter is selected, prompts for sign in when not signed in
        // save as - shown disabled when a filter set is loaded, enabled when an additional filter is added
        // update - shown disabled when filter set loaded, enabled when an additional filters is added
        // clear - shown enabled when filter selected or filter set loaded, clears filter set selection if filter set loaded
        // delete - shown enabled when filter set loaded, clears filter set selection
        if (!event.action && !event.currentTarget) {
            console.error('@acavan filterSet.onClickButton - event', event);
        }
        const action = event.action || event.currentTarget.dataset.action;
        switch (action) {
            case 'clearFilterSet':
                this.trigger('clear:allGroups');
                this.currentFilterSet = null;
                this.getChildView('filterSetsList').clearSelection();
                break;
            case 'deleteFilterSet':
                this.channels.analytics.trigger('event', { category: 'places.filter', action: 'set.delete' });
                this.modalDialog = new ModalDialog({template: templates.delete, templateContext: {type: 'filterSetLabel', name: this.currentFilterSet.attributes.name}});
                this.modalDialog.on('modalDialog:delete', _.bind(function (o) {
                    this.filterSets.remove(this.currentFilterSet);
                    this.currentFilterSet.destroy();
                    this.currentFilterSet = null;
                    this.getChildView('filterSetsList').clearSelection();
                    this.onClickButton({action: 'clearFilterSet'});
                }, this));
                break;
            case 'saveFilterSetAs':
            case 'saveFilterSet':
                this.channels.analytics.trigger('event', { category: 'places.filter', action: 'set.save' });
                if (!user.isSignedIn()) {
                    this.pendingSaveFilters = JSON.stringify(this.filters.getFilterSet());
                    if (configuration.embedded) {
                        this.channels.vaultOut.trigger('requestLogon');
                    } else {
                        this.modalDialog = new ModalDialog({template: templates.pleaseSignIn, templateContext: {}, modalModal: false});
                    }
                } else {
                    this.pendingSaveFilters = '';
                    this.modalDialog = new ModalDialog({template: templates.filterSetSave});
                    this.modalDialog.on('modalDialog:save', _.bind(function (o) {
                        let filterSet;
                        if (o.filterSetName) { // @acavan! - disable save if no name present but for now...
                            this.filterSets.create({name: o.filterSetName, jsonData: JSON.stringify(this.filters.getFilterSet())});
                        }
                        this.modalDialogCloseTimeout = setTimeout(_.bind(function () {
                            this.modalDialog.close();
                        }, this), 2000);
                    }, this));
                    this.modalDialog.on('modalDialog:closed', _.bind(function (o) {
                        clearTimeout(this.modalDialogCloseTimeout);
                        this.modalDialogCloseTimeout = null;
                    }, this));
                }
                break;
            case 'updateFilterSet':
                this.channels.analytics.trigger('event', { category: 'places.filter', action: 'set.update' });
                this.currentFilterSet.set({filterSet: this.filters.getFilterSet(), jsonData: JSON.stringify(this.filters.getFilterSet())});
                this.currentFilterSet.save();
                this.ui.updateFilterSet.prop('disabled', true);
                this.currentFilterSetString = JSON.stringify(this.serializeFilters());
                // @acavan! - this works for now but really we should get the new serialized array from filtersList view
                break;
            default:
                console.log('filterSet.onClickButton - action:%s', action);
                break;
        }
        return false;
    },
    onRender: function () {
        this.showChildView('filtersList', new FiltersList({collection: this.filters}));
        this.showChildView('filterSetsList', new FilterSetsList({collection: this.filterSets}));
    },
    onSelectFilterSet: function (filterSetId) {
        this.currentFilterSet = this.filterSets.get(filterSetId);
        this.trigger('apply:filterSet', this.currentFilterSet.attributes.filterSet);
    },
    showButtons: function (buttons, via) {
        // console.log('showButtons - via:%s', via);
        jQuery('button', this.$el).not('[data-action=clear]').hide();
        _.each(buttons.enabled || [], _.bind(function (button) {
            this.ui[button].show().prop('disabled', false);
        }, this));
        _.each(buttons.disabled || [], _.bind(function (button) {
            this.ui[button].show().prop('disabled', true);
        }, this));
    },
    updateFilters: function (serializedFilters, via) {
        const filtersString = JSON.stringify(serializedFilters);
        let filterCount;
        filterCount = this.getChildView('filtersList').updateFilters(serializedFilters); // @acavan! - this mutates serializedFilters...
        if (via === 'onApplyFilterSet') {
            this.currentFilterSetString = filtersString;
        }
        if (!filterCount) {
            this.showButtons({enabled: [], disabled: ['saveFilterSet']}, 'updateFilters');
        }
        if (filterCount && !this.currentFilterSet) {
            this.showButtons({enabled: ['saveFilterSet', 'clearFilterSet'], disabled: []}, 'updateFilters');
        }
        if (filterCount && this.currentFilterSet) {
            if (this.currentFilterSetString === filtersString) {
                this.showButtons({enabled: ['clearFilterSet', 'deleteFilterSet'], disabled: ['saveFilterSetAs', 'updateFilterSet']}, 'updateFilters');
            } else {
                this.showButtons({enabled: ['saveFilterSetAs', 'clearFilterSet', 'deleteFilterSet', 'updateFilterSet'], disabled: []}, 'updateFilters');
            }
        }
        this.getChildView('filterSetsList').skipFilterSetSelectOnReset(this.filters.length > 0); // @acavan! - needed?
    }
});
